import type { PricingState } from "../types";
import type { InjectionKey } from "#imports";

export const PRODUCT_PRICING_INJECTION_KEY = Symbol( "ProductPricing" ) as InjectionKey<PricingState>;
